import { call, put, select } from 'redux-saga/effects';

import { goToProtocolsService } from './router';
import { createProtocolRequest, deleteProtocolRequest, updateProtocolRequest } from '../requests';
import { pathSelector } from '../../../selectors';
import { createProtocol, deleteProtocol, updateProtocol } from '../../../actions';

export function* createProtocolService(data) {
  yield put(createProtocol(data));

  const { success } = yield call(createProtocolRequest, data);

  if (success) {
    yield call(goToProtocolsService);
  }
}

export function* updateProtocolService(id, data) {
  yield put(updateProtocol(id, data));
  yield call(updateProtocolRequest, id, data);
}

export function* updateCurrentProtocolService(data) {
  const { protocolId } = yield select(pathSelector);

  yield call(updateProtocolService, protocolId, data);
}

export function* deleteProtocolService(id) {
  const { protocolId } = yield select(pathSelector);

  if (id === protocolId) {
    yield call(goToProtocolsService);
  }

  yield put(deleteProtocol(id));
  yield call(deleteProtocolRequest, id);
}

export function* deleteCurrentProtocolService() {
  const { protocolId } = yield select(pathSelector);

  yield call(deleteProtocolService, protocolId);
}
